import { render } from "./ticheng.vue?vue&type=template&id=4a3bf77e&scoped=true"
import script from "./ticheng.vue?vue&type=script&lang=js"
export * from "./ticheng.vue?vue&type=script&lang=js"

import "./ticheng.vue?vue&type=style&index=0&id=4a3bf77e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3bf77e"]])

export default __exports__